import moment from "moment";
import { Column } from "react-table";
import { LicenceRenewal } from "../models/LicenceRenewal";
import { DataGrid } from "./common/DataGrid";

interface Props {
  licenceRenewals?: LicenceRenewal[] | null;
  pageCount?: number;
  onPageInfoChange: (pageSize: number, pageIndex: number) => void;
}

const AdminLicenceRenewalsGrid = ({ licenceRenewals, pageCount, onPageInfoChange }: Props) => {
  const columns: Column<LicenceRenewal>[] = [
    {
      Header: "Organization",
      id: "organization",
      accessor: (l) => l.organization.name,
    },
    {
      Header: "Product name",
      id: "productName",
      accessor: (l) => l.productName,
    },
    {
      Header: "Type",
      id: "type",
      accessor: (l) => l.type,
    },
    {
      Header: "Total price",
      id: "totalPrice",
      accessor: (l) =>
        new Intl.NumberFormat("en-GB", {
          style: "currency",
          currency: "GBP",
        }).format(l.totalPrice),
    },
    {
      Header: "Start date",
      id: "startDate",
      accessor: (l) => moment(l.startDate).format("L"),
    },
    {
      Header: "End date",
      id: "endDate",
      accessor: (l) => moment(l.endDate).format("L"),
    },
    {
      Header: "Number of users",
      id: "numberOfUsers",
      accessor: (l) => l.numberOfUsers,
    },
    {
      Header: "Creation date",
      id: "creation date",
      accessor: (l) => moment(l.dateCreated).format("L"),
    },
  ];

  return (
    <>
      <DataGrid
        columns={columns}
        data={licenceRenewals ? licenceRenewals : []}
        onPageInfoChange={onPageInfoChange}
        loading={false}
        pageCount={pageCount}
      />
    </>
  );
};

export default AdminLicenceRenewalsGrid;
